import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { filter, switchMap, take } from 'rxjs/operators';
import { EnvironmentVariables } from '../../environment-variables';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private auth: AuthService,
    private environment: EnvironmentVariables
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!request.url.startsWith(this.environment.apiPath)) {
      return next.handle(request);
    }

    return this.auth.isLoggedIn$.pipe(
      filter((isLoggedIn) => !!isLoggedIn),
      take(1),
      switchMap(() => {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${this.auth.accessToken}`,
          },
        });
        return next.handle(request);
      })
    );
  }
}
